import { render, staticRenderFns } from "./homeTop.vue?vue&type=template&id=2d921e40&scoped=true"
import script from "./homeTop.vue?vue&type=script&lang=js"
export * from "./homeTop.vue?vue&type=script&lang=js"
import style0 from "./homeTop.vue?vue&type=style&index=0&id=2d921e40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d921e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d921e40')) {
      api.createRecord('2d921e40', component.options)
    } else {
      api.reload('2d921e40', component.options)
    }
    module.hot.accept("./homeTop.vue?vue&type=template&id=2d921e40&scoped=true", function () {
      api.rerender('2d921e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/homeTop.vue"
export default component.exports